import { SelectItem } from 'primeng/api';

export enum CompanyType {
  Corporation = 'CORPORATION',
  LawFirm = 'LAW_FIRM',
  Other = 'OTHER',
}

export const COMPANY_TYPE_ITEMS: SelectItem[] = [
  { label: 'Corporation', value: CompanyType.Corporation },
  { label: 'Law Firm', value: CompanyType.LawFirm },
  { label: 'Other', value: CompanyType.Other },
];
